import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Register = () => {
  console.log('✅ Register component with username support');
  
  const [formData, setFormData] = useState({
    email: '',
    username: '',
    full_name: '',
    password: '',
    confirmPassword: '',
  });
  const [loading, setLoading] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!termsAccepted) {
      toast.error('Please accept the privacy and safety terms to continue');
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    if (formData.password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }

    if (formData.username.length < 3) {
      toast.error('Username must be at least 3 characters');
      return;
    }

    if (!/^[a-zA-Z0-9_]+$/.test(formData.username)) {
      toast.error('Username can only contain letters, numbers, and underscores');
      return;
    }

    setLoading(true);

    try {
      const response = await authAPI.register({
        email: formData.email,
        username: formData.username,
        full_name: formData.full_name,
        password: formData.password,
      });

      const { access_token, user } = response.data;
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('user', JSON.stringify(user));
      
      toast.success('Account created successfully!');
      // Force page reload to trigger App.js auth check
      setTimeout(() => {
        window.location.href = '/dashboard';
      }, 1000);
    } catch (error) {
      const errorMsg = error.response?.data?.error || error.response?.data?.message || 'Registration failed';
      toast.error(errorMsg);
      console.error('Registration error:', error);
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <ToastContainer position="top-right" autoClose={3000} theme="dark" />
      
      <div style={{
        backgroundColor: '#1a1a1a',
        border: '1px solid #333',
        borderRadius: '12px',
        padding: '40px',
        width: '100%',
        maxWidth: '450px',
        boxShadow: '0 10px 40px rgba(255, 182, 193, 0.1)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img src="/bestie_logo.png" alt="Bestie" style={{ width: '80px', height: '80px', objectFit: 'contain', display: 'block' }} />
          </div>
          <h1 style={{ 
            fontSize: '2rem', 
            fontWeight: '600', 
            marginBottom: '10px',
            color: '#ffffff',
            margin: '0 0 10px 0'
          }}>
            Join BestieConnect
          </h1>
          <p style={{ color: '#999', fontSize: '0.95rem', margin: 0 }}>
            Create your account to get started
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ 
              display: 'block', 
              marginBottom: '8px', 
              color: '#ffffff',
              fontSize: '0.9rem',
              fontWeight: '500'
            }}>
              👤 Full Name
            </label>
            <input
              type="text"
              name="full_name"
              value={formData.full_name}
              onChange={handleChange}
              required
              placeholder="John Doe"
              style={{
                width: '100%',
                padding: '12px 15px',
                backgroundColor: '#0a0a0a',
                border: '1px solid #333',
                borderRadius: '8px',
                color: '#ffffff',
                fontSize: '1rem',
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ 
              display: 'block', 
              marginBottom: '8px', 
              color: '#ffffff',
              fontSize: '0.9rem',
              fontWeight: '500'
            }}>
              🏷️ Username
            </label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              placeholder="johndoe123"
              minLength="3"
              pattern="[a-zA-Z0-9_]+"
              title="Username can only contain letters, numbers, and underscores"
              style={{
                width: '100%',
                padding: '12px 15px',
                backgroundColor: '#0a0a0a',
                border: '1px solid #333',
                borderRadius: '8px',
                color: '#ffffff',
                fontSize: '1rem',
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
            <small style={{ color: '#999', fontSize: '0.8rem' }}>
              Letters, numbers, and underscores only
            </small>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ 
              display: 'block', 
              marginBottom: '8px', 
              color: '#ffffff',
              fontSize: '0.9rem',
              fontWeight: '500'
            }}>
              📧 Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="your.email@example.com"
              style={{
                width: '100%',
                padding: '12px 15px',
                backgroundColor: '#0a0a0a',
                border: '1px solid #333',
                borderRadius: '8px',
                color: '#ffffff',
                fontSize: '1rem',
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ 
              display: 'block', 
              marginBottom: '8px', 
              color: '#ffffff',
              fontSize: '0.9rem',
              fontWeight: '500'
            }}>
              🔒 Password
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="At least 6 characters"
              minLength="6"
              style={{
                width: '100%',
                padding: '12px 15px',
                backgroundColor: '#0a0a0a',
                border: '1px solid #333',
                borderRadius: '8px',
                color: '#ffffff',
                fontSize: '1rem',
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '30px' }}>
            <label style={{ 
              display: 'block', 
              marginBottom: '8px', 
              color: '#ffffff',
              fontSize: '0.9rem',
              fontWeight: '500'
            }}>
              🔒 Confirm Password
            </label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              placeholder="Re-enter your password"
              style={{
                width: '100%',
                padding: '12px 15px',
                backgroundColor: '#0a0a0a',
                border: '1px solid #333',
                borderRadius: '8px',
                color: '#ffffff',
                fontSize: '1rem',
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{
            marginBottom: '25px',
            padding: '15px',
            backgroundColor: '#0a0a0a',
            border: '1px solid #333',
            borderRadius: '8px'
          }}>
            <div style={{
              display: 'flex',
              gap: '12px',
              alignItems: 'flex-start',
              marginBottom: '10px'
            }}>
              <input
                type="checkbox"
                id="termsCheckbox"
                checked={termsAccepted}
                onChange={(e) => setTermsAccepted(e.target.checked)}
                style={{
                  marginTop: '4px',
                  cursor: 'pointer',
                  width: '18px',
                  height: '18px',
                  accentColor: '#FFB6C1'
                }}
              />
              <div style={{ flex: 1 }}>
                <label 
                  htmlFor="termsCheckbox"
                  style={{
                    color: '#ffffff',
                    fontSize: '0.9rem',
                    cursor: 'pointer',
                    display: 'block',
                    marginBottom: '8px'
                  }}
                >
                  I accept the Privacy and Safety Terms
                </label>
                <button
                  type="button"
                  onClick={() => setShowTermsModal(!showTermsModal)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#FFB6C1',
                    fontSize: '0.85rem',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    padding: '0',
                    fontWeight: '500'
                  }}
                >
                  {showTermsModal ? '▼ Hide Terms' : '▶ View Terms'}
                </button>
              </div>
            </div>

            {showTermsModal && (
              <div style={{
                marginTop: '15px',
                paddingTop: '15px',
                borderTop: '1px solid #333',
                maxHeight: '300px',
                overflowY: 'auto',
                color: '#ccc',
                fontSize: '0.85rem',
                lineHeight: '1.6'
              }}>
                <h4 style={{ color: '#FFB6C1', marginTop: 0, marginBottom: '10px' }}>
                  📋 Privacy & Safety Terms
                </h4>
                
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#ffffff' }}>1. Privacy Protection</strong>
                  <p style={{ margin: '5px 0 0 0' }}>
                    We are committed to protecting your personal information. Your data will never be sold or shared with third parties without your explicit consent. All personal information is encrypted and stored securely.
                  </p>
                </div>

                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#ffffff' }}>2. Safe Community</strong>
                  <p style={{ margin: '5px 0 0 0' }}>
                    BestieConnect is dedicated to maintaining a safe and respectful community. We have zero tolerance for harassment, hate speech, discrimination, and illegal activities. Violations will result in account suspension or termination.
                  </p>
                </div>

                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#ffffff' }}>3. Content Responsibility</strong>
                  <p style={{ margin: '5px 0 0 0' }}>
                    You are responsible for the content you share. Do not post illegal, offensive, or harmful content. We reserve the right to moderate and remove content that violates our community standards.
                  </p>
                </div>

                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#ffffff' }}>4. Mental Health Support</strong>
                  <p style={{ margin: '5px 0 0 0' }}>
                    BestieConnect provides peer support but is not a substitute for professional mental health care. If you are in crisis, please contact a mental health professional or crisis helpline immediately.
                  </p>
                </div>

                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#ffffff' }}>5. Data Usage</strong>
                  <p style={{ margin: '5px 0 0 0' }}>
                    We use your data to improve our services and provide better recommendations. You have the right to access, modify, or delete your personal data at any time through your account settings.
                  </p>
                </div>

                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#ffffff' }}>6. User Conduct</strong>
                  <p style={{ margin: '5px 0 0 0' }}>
                    You agree to use BestieConnect responsibly. Do not engage in bullying, spam, impersonation, or any form of abuse. Users who violate these rules will be disciplined according to our safety policy.
                  </p>
                </div>

                <div>
                  <strong style={{ color: '#ffffff' }}>7. Terms Acceptance</strong>
                  <p style={{ margin: '5px 0 0 0' }}>
                    By checking this box, you confirm that you have read, understood, and agree to abide by these privacy and safety terms. You also consent to our privacy policy and cookie usage.
                  </p>
                </div>
              </div>
            )}
          </div>

          <button 
            type="submit" 
            disabled={loading || !termsAccepted}
            style={{
              width: '100%',
              padding: '14px',
              backgroundColor: termsAccepted ? '#FFB6C1' : '#666',
              color: termsAccepted ? '#000000' : '#999',
              border: 'none',
              borderRadius: '8px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: (loading || !termsAccepted) ? 'not-allowed' : 'pointer',
              opacity: (loading || !termsAccepted) ? 0.6 : 1,
              transition: 'all 0.2s'
            }}
          >
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>

        <div style={{ 
          marginTop: '30px', 
          textAlign: 'center',
          paddingTop: '20px',
          borderTop: '1px solid #333'
        }}>
          <p style={{ color: '#999', fontSize: '0.9rem', marginBottom: '10px' }}>
            Already have an account?{' '}
            <Link 
              to="/login" 
              style={{ 
                color: '#FFB6C1', 
                textDecoration: 'none',
                fontWeight: '600'
              }}
            >
              Sign in
            </Link>
          </p>
          <p style={{ color: '#999', fontSize: '0.9rem', margin: 0 }}>
            <Link 
              to="/" 
              style={{ 
                color: '#666', 
                textDecoration: 'none',
                fontWeight: '500'
              }}
            >
              ← Back to Home
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
